<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
    class="page-title-container"
    :class="{ 'border': showBorder }"
  >
    <el-col>
      <div class="left-title">{{ title }}</div>
    </el-col>

    <el-col v-if="showBack" class="text-right">
      <el-button size="mini" plain @click="$router.go(-1)">返 回</el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'JR_PageHeader',
  props: {
    title: {
      required: true,
      type: String,
    },
    showBorder: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.page-title-container {
  min-height: 28px;
  margin-bottom: 10px;

  &.border {
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 15px;
  }

  .left-title {
    font-size: 16px;
    position: relative;
    padding-left: 12px;
  }
  .left-title::before {
    content: '';
    display: block;
    width: 4px;
    height: 100%;
    background-color: $cyan;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
